import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Avatar from '@/components/common/Avatar/Avatar';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import moment from 'moment';
@connect((store) => {
  return {
    loggedUser: store.loggedUser,
  };
})
class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  render() {
    const { email_to, cc, sender, bcc, subject, dateAdded } = this.props.data;
    const senderName = sender.includes('<')
      ? sender.split('<')
      : sender.split('@');
    const toName = email_to.includes('<') ? email_to.split('<')[0] : email_to;

    const open = Boolean(this.state.anchorEl);

    const handleClick = (event) => {
      this.setState({ ...this.state, anchorEl: event.currentTarget });
    };

    const handleClose = () => {
      this.setState({ ...this.state, anchorEl: null });
    };

    const iscurrentDate = moment(dateAdded).isSame(new Date(), 'day');
    const date = `${iscurrentDate ? moment(dateAdded).format('hh:mm A') : moment(dateAdded).format('ddd, MMM DD, hh:mm A')}  (${moment(dateAdded).fromNow()})`;
    const mailedBy = sender.split('@')[1].replace('>', '');
    return (
      <div class="emailViewerHeader">
        <Avatar name={senderName[0]} disableTooltip={true} />

        <div class="emailViewerInfo">
          <strong>{senderName[0]} </strong>{' '}
          <span>{sender.includes('<') ? '<' + senderName[1] : ''} </span>
          <div class="dateContainer">
            <p class="m0">{date}</p>
          </div>
          <div class="to-Container">
            <p class="m0">to: {toName}</p>

            <a onClick={handleClick} class={`${open ? 'active' : ''}`}>
              <i class="material-icons mr5">arrow_drop_down</i>
            </a>
          </div>
          <Popper
            open={open}
            anchorEl={this.state.anchorEl}
            placement="bottom-start"
            style={{ zIndex: 100 }}
          >
            <ClickAwayListener onClickAway={handleClose}>
              <div class="emailInfoModal">
                <div class="label-div mb10">
                  <label>from: </label>
                  <div>
                    <p class="m0">{sender}</p>
                  </div>
                </div>
                <div class="label-div mb10">
                  <label>to: </label>
                  <div>
                    <p class="m0">{email_to}</p>
                  </div>
                </div>
                {cc && (
                  <div class="label-div mb10">
                    <label>cc: </label>
                    <div>
                      <p class="m0">{cc}</p>
                    </div>
                  </div>
                )}
                {bcc && (
                  <div class="label-div mb10">
                    <label>bcc: </label>
                    <div>
                      <p class="m0">{bcc}</p>
                    </div>
                  </div>
                )}
                <div class="label-div mb10">
                  <label>date: </label>
                  <div>
                    <p class="m0">
                      {moment(dateAdded).format('MMM DD, YYYY, hh:mm A')}
                    </p>
                  </div>
                </div>

                <div class="label-div mb10">
                  <label>subject: </label>
                  <div>
                    <p class="m0">{subject}</p>
                  </div>
                </div>

                <div class="label-div mb10">
                  <label>mailed-by: </label>
                  <div>
                    <p class="m0">{mailedBy}</p>
                  </div>
                </div>
              </div>
            </ClickAwayListener>
          </Popper>
        </div>
      </div>
    );
  }
}

export default Header;
